import axios from 'axios';
import queryString from 'query-string';
import actions from '../actions/records';

export default {
	namespaced: true,
	state: {
		sets: [],
		records: [],
		setLinks: [],
		recordLinks: [],
		setPaginationMetadata: {},
		recordsPaginationMetadata: {},
	},
	mutations: {
		[actions.SET_SET_DATA]: (state, data) => {
			state.setLinks = data.links;
			state.sets = data.entities;
			state.setPaginationMetadata = data.paginationMetadata;
		},
		[actions.SET_RECORDS_DATA]: (state, data) => {
			state.recordLinks = data.links;
			state.records = data.entities;
			state.recordsPaginationMetadata = data.paginationMetadata;
		},
		[actions.SET_SET_LINKS]: (state, links) => {
			state.setLinks = links;
		},
		[actions.SET_RECORDS_LINKS]: (state, links) => {
			state.recordLinks = links;
		},
		[actions.REMOVE_SET_DATA]: (state) => {
			state.sets = [];
			state.setPaginationMetadata = {};
		},
		[actions.REMOVE_RECORDS_DATA]: (state) => {
			state.records = [];
			state.recordsPaginationMetadata = {};
		},
	},
	actions: {
		[actions.GET_RECORDSET_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'recordsets_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_SET_LINKS, data.links);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_RECORDS_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'records_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_RECORDS_LINKS, data.links);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_RECORDSETS]: async (
			{ commit, state },
			{ masterOrgId, queryParameters }) => {
			try {
				commit(actions.REMOVE_SET_DATA);

				const link = state.setLinks.find(x => x.rel === 'get_recordsets_of_organization' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{organizationId}', masterOrgId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_RECORDSETBYID]: async (
			{ state },
			id) => {
			try {
				const link = state.setLinks.find(x => x.rel === 'get_by_id' && x.templated);
				const href = link.href
					.replace('{recordSetId}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_RECORDSET]: async ({ state }, { recordset, setId }) => {
			try {
				const link = state.setLinks.find(x => x.rel === 'edit_recordset');
				const href = link.href
					.replace('{recordSetId}', setId);
				await axios.put(href, recordset);
			} catch (error) {
				throw error;
			}
		},
		[actions.ADD_RECORDSET]: async ({ state }, { recordset, masterOrgId }) => {
			try {
				const link = state.setLinks.find(x => x.rel === 'create_recordset');
				const href = link.href
					.replace('{organizationId}', masterOrgId);
				await axios.post(href, recordset);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_RECORDSET]: async ({ state }, setId) => {
			try {
				const link = state.setLinks.find(x => x.rel === 'delete_recordset');
				const href = link.href.replace('{recordSetId}', setId);
				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_RECORDS]: async (
			{ commit, state },
			{ recordSetId, queryParameters }) => {
			try {
				commit(actions.REMOVE_RECORDS_DATA);

				const link = state.recordLinks.find(x => x.rel === 'get_records_of_recordset' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{recordSetId}', recordSetId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_RECORDS_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_RECORDBYID]: async (
			{ state },
			id) => {
			try {
				const link = state.recordLinks.find(x => x.rel === 'get_by_id' && x.templated);
				const href = link.href
					.replace('{recordId}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_RECORD]: async ({ state }, { record, id }) => {
			try {
				const link = state.recordLinks.find(x => x.rel === 'edit_record');
				const href = link.href
					.replace('{recordId}', id);
				await axios.put(href, record);
			} catch (error) {
				throw error;
			}
		},
		[actions.ADD_RECORD]: async ({ state }, { record, setId }) => {
			try {
				const link = state.recordLinks.find(x => x.rel === 'create_record');
				const href = link.href
					.replace('{recordSetId}', setId);
				await axios.post(href, record);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_RECORD]: async ({ state }, id) => {
			try {
				const link = state.recordLinks.find(x => x.rel === 'delete_record');
				const href = link.href.replace('{recordId}', id);
				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		RecordSets: state => state.sets,
		Records: state => state.records,
		RecordSetLinks: state => state.setLinks,
		RecordLinks: state => state.recordLinks,
		RecordSetPagination: state => state.setPaginationMetadata,
		RecordPagination: state => state.recordsPaginationMetadata,
	},
};
